import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ECWID_STORE_ID, ECWID_ACCESS_TOKEN } from "../config/EcwidConfig";

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  // handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // 1️⃣ Check if customer already exists by email
      const checkResponse = await fetch(
        `https://app.ecwid.com/api/v3/${ECWID_STORE_ID}/customers?email=${formData.email}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${ECWID_ACCESS_TOKEN}`,
          },
        }
      );
      const existingCustomers = await checkResponse.json();

      if (existingCustomers.items && existingCustomers.items.length > 0) {
        // 2️⃣ If customer exists → show message and stop here
        // But also store the password if it doesn't exist in localStorage
        const savedPassword = localStorage.getItem(`pw_${formData.email}`);
        if (!savedPassword) {
          // Store the password for future logins
          localStorage.setItem(`pw_${formData.email}`, formData.password);
          alert("Account found. Password has been saved for future logins.");
        } else {
          alert("This email is already registered. Please Sign In instead.");
        }
        navigate("/signin");
        return;
      }

      const response = await fetch(
        `https://app.ecwid.com/api/v3/${ECWID_STORE_ID}/customers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${ECWID_ACCESS_TOKEN}`,
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
            billingPerson: {
              name: formData.name,
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to create customer");
      }

      const data = await response.json();

      // Clear any existing customer data first
      localStorage.removeItem("customer");
      localStorage.removeItem("customerProfile");
      localStorage.removeItem("customerEmail");
      // Also clear any existing password for this email
      localStorage.removeItem(`pw_${formData.email}`);

      // Store new customer data
      localStorage.setItem(`pw_${formData.email}`, formData.password);
      localStorage.setItem("customerProfile", JSON.stringify(data));
      localStorage.setItem("customerEmail", formData.email);

      navigate("/signin");
      alert("Account created successfully 🎉");
      console.log("Customer Created:", data);
    } catch (error) {
      console.error("Error:", error);
      alert("Error creating account ❌");
    }
  };

  return (
    <div
      className="flex items-center justify-center p-3 min-h-[550px] bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%"
      style={{
        background: `url('../assets/signup-bg.jpg') no-repeat top right`,
        height: "100vh",
        backgroundSize: "cover",
      }}
    >
      <div className="w-full max-w-md p-5 bg-white rounded-lg ms-0 md:ms-48 shadow-sm border border-gray-300">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Create an Account
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="w-full bg-[#82b016] text-white py-2 rounded-md hover:bg-gray-700 transition"
          >
            Sign Up
          </button>
          <p className="text-sm text-center text-gray-600 mt-4">
            Already have an account?{" "}
            <Link to="/SignIn" className="text-[#82b016] hover:underline">
              Sign In
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
